(function () {
	document.addEventListener("DOMContentLoaded", async () => {

		if (!document.querySelector(".site-footer__colophon-select-language") || !document.querySelector(".site-footer__colophon-select-language .site-footer__select-language")) {
			return;
		}

		const selectCountrySelected = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--item-selected");
		const selectCountryItems = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--items");
		const selectCountryItem = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--item")

		selectCountrySelected.addEventListener("click", function (event) {
			event.preventDefault();

			selectCountrySelected.classList.add("open");
			selectCountryItems.style.display = "block";
		});

		document.addEventListener("click", function (event) {
			if (!event.target.closest(".site-footer__select-language")) {
				selectCountryItems.style.display = "none";
				selectCountrySelected.classList.remove("open");
			}
		});
	});
})();
